<template>
    <v-app>
        <v-row justify="center">
            <v-col cols="12" sm="3" md="3" lg="3" style="background-color:#1271A6" class="pr-0 pt-0" justify="center">
                <CPriAlumnoCabecera v-if="dPriAlumno" :pPriAlumno="dPriAlumno"/>
                <v-select v-model="dAccion" label="Accion" :items="[{text: 'Datos Generales', value: 1},{text: 'Seguimiento', value: 2},{text: 'Becas', value: 3},{text: 'Otro Instituto', value: 4}]" solo></v-select>
                <CMatMatriculaListByIdAlumno v-if="$route.params.pIdAlumno" :pIdAlumno="parseInt($route.params.pIdAlumno)" ref="refMatMatriculaListByIdAlumno"/>
            </v-col>
            <v-col v-if="dAccion==1" cols="12" sm="9" md="9" lg="9" class="pa-1 blue lighten-5">
                <v-tabs v-model="dTab">
                    <v-tab><v-icon left>person</v-icon>Generales</v-tab>
                    <v-tab><v-icon left>contact_phone</v-icon>Contacto</v-tab>
                    <v-tab><v-icon left>file_copy</v-icon>Documentos</v-tab>
                    <v-tab-item>
                        <CPriAlumnoItem v-if="dPriAlumno" :pIdAlumno="parseInt($route.params.pIdAlumno)" />
                    </v-tab-item>
                    <v-tab-item>
                        <CTlfAlumno v-if="dPriAlumno" :pIdAlumno="parseInt($route.params.pIdAlumno)" />
                    </v-tab-item>
                    <v-tab-item>
                        <CPriAlumnoDocs v-if="dPriAlumno" :pIdAlumno="parseInt($route.params.pIdAlumno)" />
                    </v-tab-item>
                </v-tabs>
            </v-col>
            <v-col v-if="dAccion==2" cols="12" sm="9" md="9" lg="9" class="pa-1 blue lighten-5">
                <CMatConsejeria :pIdAlumno="parseInt($route.params.pIdAlumno)"/>
            </v-col>
            <v-col v-if="dAccion==3" cols="12" sm="9" md="9" lg="9" class="pa-1 blue lighten-5">
                <CPriAlumnosBecado :pIdAlumno="parseInt($route.params.pIdAlumno)"/>
            </v-col>
            <v-col v-if="dAccion==4" cols="12" sm="9" md="9" lg="9" class="pa-1 blue lighten-5">
                <CPriAlumnosInstituto :pIdAlumno="parseInt($route.params.pIdAlumno)"/>
            </v-col>
        </v-row>
    </v-app>
</template>
<script>
import gql from 'graphql-tag';
import CPriAlumnoCabecera from '@/components/PRI/PriAlumnoCabecera.vue';
import CPriAlumnoItem from '@/components/PRI/PriAlumnoItem.vue';
import CPriAlumnoDocs from '@/components/PRI/PriAlumnoDocs.vue';
import CTlfAlumno from '@/components/Academico/TlfAlumno.vue';
import CMatMatriculaListByIdAlumno from '@/components/Academico/MatMatriculaListByIdAlumno.vue';
import CMatConsejeria from '@/components/Academico/MatConsejeria.vue'
import CPriAlumnosBecado from '@/components/Academico/PriAlumnosBecado.vue'
import CPriAlumnosInstituto from '@/components/PRI/PriAlumnosInstituto.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    name: 'AlumnoItem',
    components: {CPriAlumnoCabecera, CPriAlumnoItem, CPriAlumnoDocs, CMatMatriculaListByIdAlumno, CTlfAlumno, CMatConsejeria, CPriAlumnosBecado, CPriAlumnosInstituto},
    mounted(){
        if(this.$route.params.pIdAlumno)
            this.fuLoad(this.$route.params.pIdAlumno);
    },
    data: () => ({
        dPriAlumno: null,
        dTab:0,
        dAccion: 1,
    }),
    methods: {
        async fuLoad(p_IdAlumno) {
            this.dLoading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query matriculaPrev($IdAlumno: ID!){
                            prialumno(IdAlumno: $IdAlumno){
                                IdAlumno
                                Alumno
                                DNI
                                Codigo
                                Celular
                                docs
                                priservicio{
                                    IdServicio
                                    Iniciales
                                    Descripcion
                                }
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IdAlumno: p_IdAlumno,
                    }
                })                
                this.dPriAlumno = response.data.prialumno;
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dLoading = false;
            }
        },
    }
}
</script>